import React, { useState, useEffect } from "react";
import {
    Box, Typography, TextField, Paper, Accordion, AccordionSummary,
    AccordionDetails, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, CircularProgress, TablePagination, Chip,
    Tooltip, IconButton, MenuItem, Select, FormControl, InputLabel
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import MoveUpIcon from "@mui/icons-material/MoveUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import configServ from "../../services/config";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../Components/DatePicker/CustomDateRangePicker";
import pdfImage from "../../Components/Assets/images/pdf.jfif";
import excelImage from "../../Components/Assets/images/excel.png";
import { useSelector } from "react-redux";
// Note: Inka logic aapko Site Transfer data ke according modify karna hoga
import DownloadTransferPdf from "../../Components/Download/DownloadTransferPdf";
import DownloadTransferExcel from "../../Components/Download/DownloadTransferExcel";

const SiteTransferReport = () => {
    const [report, setReport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [fromCustomer, setFromCustomer] = useState("all");
    const [toCustomer, setToCustomer] = useState("all");
    const [customerList, setCustomerList] = useState([]); // Dropdown ke liye
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [dateRange, setDateRange] = useState([null, null]);
    const [openBackdrop, setOpenBackdrop] = useState(false);

    const { company_id, companyName } = useSelector((state) => state.GlobalVariables);

    // Fetch Report Data
    const fetchTransferReport = async () => {
        setLoading(true);
        try {
            const result = await configServ.getSiteTransferReport({
                company_id,
                search,
                search_type: fromCustomer,
                page: page + 1,
                per_page: rowsPerPage,
                start_date: dateRange[0] ? dayjs(dateRange[0]).format("YYYY-MM-DD") : "",
                end_date: dateRange[1] ? dayjs(dateRange[1]).format("YYYY-MM-DD") : "",
            });

            if (result.success) {
                setReport(result.data);
                setTotalCount(result.total || 0);
            } else {
                setReport([]);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTransferReport();
    }, [page, rowsPerPage, search, dateRange, fromCustomer, toCustomer]);

    useEffect(() => {
        setPage(0); // ✅ reset page
    }, [search, dateRange, fromCustomer, toCustomer]);

    // Download Handlers
    const handleDownloadPdf = () => DownloadTransferPdf(report, companyName, setOpenBackdrop);
    const handleDownloadExcel = () => DownloadTransferExcel(report, companyName, setOpenBackdrop);

    return (
        <Box sx={{ backgroundColor: "#f5f5f5", minHeight: "100vh", width: "100%" }}>
            {/* Filters Header */}
            <Paper sx={{ p: 1, mb: 3 }}>
                <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom>
                    Site Transfer Report
                </Typography>

                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                    {/* From Customer Filter */}
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <InputLabel>From Customer</InputLabel>
                        <Select
                            value={fromCustomer}
                            label="From Customer"
                            onChange={(e) => setFromCustomer(e.target.value)}
                        >
                            <MenuItem value="all">All Customers</MenuItem>
                            <MenuItem value="from_customer">From Customer</MenuItem>
                            <MenuItem value="to_customer">To Customer</MenuItem>

                            {/* customerList map here */}
                        </Select>
                    </FormControl>



                    <TextField
                        size="small"
                        placeholder="Search........"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{ startAdornment: <SearchIcon sx={{ color: "gray", mr: 1 }} /> }}
                        sx={{ width: 220 }}
                    />

                    <CustomDateRangePicker value={dateRange} onChange={setDateRange} />

                    <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
                        <Tooltip title="Download PDF"><IconButton onClick={handleDownloadPdf}><img src={pdfImage} width={28} /></IconButton></Tooltip>
                        <Tooltip title="Download Excel"><IconButton onClick={handleDownloadExcel}><img src={excelImage} width={28} /></IconButton></Tooltip>
                    </Box>
                </Box>
            </Paper>

            {/* Main Content */}
            {loading ? (
                <Box sx={{ textAlign: "center", mt: 10, p: 1 }}><CircularProgress /></Box>
            ) : report.length > 0 ? (
                <>
                    {report.map((transfer) => (
                        <Accordion key={transfer.id} sx={{ mb: 1, borderRadius: 2, }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Box sx={{ display: "flex", alignItems: "center", width: "100%", pr: 2 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <Typography fontWeight="bold">{transfer.from_customer?.contact_name}</Typography>
                                            <ArrowForwardIcon sx={{ fontSize: 16, color: "gray" }} />
                                            <Typography fontWeight="bold" color="primary">{transfer.to_customer?.contact_name}</Typography>
                                        </Box>
                                        <Typography variant="caption" color="textSecondary">
                                            Date: {dayjs(transfer.created_at).format("DD MMM YYYY")}
                                        </Typography>
                                    </Box>
                                    <Chip
                                        label={transfer.from_challan?.challan_no || 'N/A'}
                                        size="small"
                                        color="info"
                                        variant="outlined"
                                        sx={{ mr: 1 }}
                                    />
                                    <Chip
                                        label={transfer.is_manual_entry ? "Manual" : "Auto"}
                                        size="small"
                                        color={transfer.is_manual_entry ? "secondary" : "success"}
                                        variant="outlined"
                                    />
                                </Box>
                            </AccordionSummary>

                            <AccordionDetails sx={{ backgroundColor: "#fafafa" }}>
                                <TableContainer component={Paper} variant="outlined">
                                    <Table size="small">
                                        <TableHead sx={{ backgroundColor: "#f0f4f8" }}>
                                            <TableRow>
                                                <TableCell><b>Item Name</b></TableCell>
                                                <TableCell align="right"><b>Qty</b></TableCell>
                                                <TableCell align="right"><b>Rate</b></TableCell>
                                                <TableCell align="right"><b>Amount</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {transfer.items.map((item) => (
                                                <TableRow key={item.id}>
                                                    <TableCell>{item.item_name}</TableCell>
                                                    <TableCell align="right">{item.qty}</TableCell>
                                                    <TableCell align="right">₹{item.rate}</TableCell>
                                                    <TableCell align="right"><b>₹{item.amount}</b></TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                    <TablePagination
                        component="div"
                        count={totalCount}
                        page={page}
                        onPageChange={(e, p) => setPage(p)}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                    />
                </>
            ) : (
                <Paper sx={{ p: 5, textAlign: "center" }}><Typography>No Transfers Found</Typography></Paper>
            )}
        </Box>
    );
};

export default SiteTransferReport;